// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/deployer/v2/deployment_status_service.proto (package ai.h2o.mlops.deployer.v2, syntax proto3)
/* eslint-disable */

import type { DeploymentStatus } from "./deployment_status_pb";
import type { Status } from "../../../../../google/rpc/status_pb";
import { RPC } from "../../../../../runtime";

/**
 * The request message for getting an deployment's status.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.GetDeploymentStatusRequest
 */
export type GetDeploymentStatusRequest = {
/**
 * The name of the status deployment to get, in the form:
 * "workspaces/{workspace}/deployment/{deployment}/status"
 *
 * @generated from field: string name = 1;
 */
name: string;
}
;
/**
 * The response message for getting an deployment's status.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.GetDeploymentStatusResponse
 */
export type GetDeploymentStatusResponse = {
/**
 * The retrieved deployment's status.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.DeploymentStatus deployment_status = 1;
 */
deploymentStatus?: DeploymentStatus;
}
;
/**
 * The request message for BatchGetDeploymentStatus.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.BatchGetDeploymentStatusesRequest
 */
export type BatchGetDeploymentStatusesRequest = {
/**
 * Required. The resource name of the workspace to get deployments statuses.
 * Format: `workspaces/{workspace}`
 *
 * @generated from field: string parent = 1;
 */
parent: string;
/**
 * The name of the status deployment to get.
 * // A maximum of 1000 statuses can be retrieved in a batch.
 * Format: "workspaces/{workspace}/deployment/{deployment}/status"
 *
 * @generated from field: repeated string names = 2;
 */
names: string[];
}
;
/**
 * The response message for getting BatchGetDeploymentStatus.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.BatchGetDeploymentStatusesResponse
 */
export type BatchGetDeploymentStatusesResponse = {
/**
 * The retrieved deployment's status.
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.DeploymentStatus deployment_statuses = 1;
 */
deploymentStatuses?: DeploymentStatus[];
/**
 * Errors for specific deployments statuses
 *
 * @generated from field: map<string, google.rpc.Status> errors = 2;
 */
errors?: { [key: string]: Status };
}
;
/**
 * Retrieves a single deployment's status.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentStatusService.GetDeploymentStatus
 */
export const DeploymentStatusService_GetDeploymentStatus = new RPC<GetDeploymentStatusRequest,GetDeploymentStatusResponse>("GET", "/v2/{name=workspaces/*/deployments/*/status}");
/**
 * Retrieves a list of deployments statuses for provided names
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.DeploymentStatusService.BatchGetDeploymentStatuses
 */
export const DeploymentStatusService_BatchGetDeploymentStatuses = new RPC<BatchGetDeploymentStatusesRequest,BatchGetDeploymentStatusesResponse>("GET", "/v2/{parent=workspaces/*}/deployments/status:batchGet");
